/**
 * Página /inscribete (front.includes.qubit.inscribete, diseño Claude Design
 * "QUBIT-Inscripcion"). Solo navegación y ayudas de UI sobre formularios reales: el
 * envío final va siempre a la ruta real del formulario (register, login,
 * front.one-step-registration.store o front.inscripcion.store).
 *
 * - Pasos: cada <section data-q-step> es un paso; data-q-skip lo omite (p. ej. "Datos"
 *   si no hay nada que pedir). El formulario lleva novalidate: se valida paso a paso
 *   aquí (JsValidator o validación nativa) y otra vez entero antes de enviar.
 * - Paso Cuenta: pestañas registro / login. El login es otro <form> (#q-form-login) y
 *   sus campos se asocian con el atributo form=""; tras iniciar sesión se vuelve a
 *   /inscribete (url.intended, ver FrontInscribeteController).
 */

const money = (value) =>
    Number(value).toLocaleString('es-ES', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 });

function initPasswordMeters(scope) {
    scope.querySelectorAll('[data-q-password]').forEach((input) => {
        const wrap = input.closest('form, [data-q-inscribete], main, body').querySelector('[data-q-pw-meter-wrap]');
        const confirm = input.form ? input.form.querySelector('[data-q-password-confirm]') : null;
        const bars = wrap ? wrap.querySelectorAll('.q-pw-meter > span') : [];
        const label = wrap ? wrap.querySelector('[data-q-pw-label]') : null;
        const labels = ['Mínimo 8 caracteres, con mayúscula, minúscula y número', 'Débil', 'Aceptable', 'Buena', 'Excelente'];

        const update = () => {
            const value = input.value;
            const meetsRule = /[a-z]/.test(value) && /[A-Z]/.test(value) && /\d/.test(value) && value.length >= 8;
            let score = value.length === 0 ? 0 : value.length < 8 ? 1 : value.length < 11 ? 2 : /[^a-zA-Z]/.test(value) && value.length >= 12 ? 4 : 3;
            if (!meetsRule && score > 1) score = 1;
            const color = score < 2 ? 'oklch(0.62 0.16 30)' : score < 4 ? 'var(--color-q-blue)' : 'oklch(0.55 0.13 160)';
            bars.forEach((bar, i) => {
                bar.style.background = i < score ? color : '';
            });
            if (label) label.textContent = value.length > 0 && !meetsRule ? 'Falta mayúscula, minúscula, número u 8 caracteres' : labels[score];
            if (confirm) confirm.setCustomValidity(confirm.value && confirm.value !== value ? 'Las contraseñas no coinciden.' : '');
        };

        input.addEventListener('input', update);
        if (confirm) confirm.addEventListener('input', update);
    });
}

function initInscribete(page) {
    const mode = page.dataset.mode;
    const form = page.querySelector('[data-q-main-form]');
    const clientError = page.querySelector('[data-q-client-error]');
    const footTop = page.querySelector('[data-q-foot-top]');
    const footMain = page.querySelector('[data-q-foot-main]');
    const backBtn = page.querySelector('[data-q-back]');
    const nextBtn = page.querySelector('[data-q-next]');
    const nextLabel = page.querySelector('[data-q-next-label]');
    const submitBtn = page.querySelector('[data-q-submit]');
    const submitLabel = page.querySelector('[data-q-submit-label]');
    const accountDone = form ? form.hasAttribute('data-account-done') : false;

    const allSteps = form ? [...form.querySelectorAll('[data-q-step]')] : [];
    const steps = allSteps.filter((step) => !step.hasAttribute('data-q-skip'));
    let current = 0;
    let tab = 'registro';

    /* ---------- Pestañas registro / login (paso Cuenta) ---------- */
    function setTab(next) {
        const cuenta = page.querySelector('[data-q-step="cuenta"]');
        if (!cuenta || !cuenta.querySelector('[data-q-tabpanel="login"]')) return;
        tab = next;
        cuenta.querySelectorAll('[data-q-tabpanel]').forEach((p) => {
            const active = p.dataset.qTabpanel === tab;
            p.hidden = !active;
            // Los campos de la pestaña oculta no deben bloquear la validación.
            p.querySelectorAll('input, select, textarea').forEach((el) => {
                if (!el.hasAttribute('form')) el.disabled = !active;
            });
        });
        cuenta.querySelectorAll('[data-q-switch-q], [data-q-switch]').forEach((el) => {
            el.textContent = el.dataset[tab === 'login' ? 'textLogin' : 'textRegistro'];
        });
        hideError();
        refresh();
    }
    page.querySelectorAll('[data-q-switch]').forEach((btn) =>
        btn.addEventListener('click', () => setTab(tab === 'login' ? 'registro' : 'login')),
    );

    /* ---------- Validación ---------- */
    const showError = (message) => {
        if (!clientError) return;
        clientError.textContent = message;
        clientError.hidden = false;
    };
    function hideError() {
        if (clientError) clientError.hidden = true;
    }
    const controlsOf = (section) =>
        [...section.querySelectorAll('input, select, textarea')].filter(
            (el) => !el.disabled && el.type !== 'hidden' && (!el.form || el.form === form) && !el.closest('[hidden]:not([data-q-step])'),
        );
    // JsValidator (proengsoft) sobre el formulario principal, si la página lo ha
    // inicializado (solo en los formularios que crean cuenta). Se busca en el momento
    // de validar porque se inicializa en jQuery(document).ready, después de este
    // módulo. Se ignoran los campos que no son de la FormRequest (q-native) y los del
    // formulario de login, que están dentro del panel pero pertenecen a otro <form>.
    const jsValidator = () => {
        const validator = form && window.jQuery ? window.jQuery(form).data('validator') : null;
        if (validator && !validator.qPatched) {
            validator.settings.ignore = [validator.settings.ignore, '.q-native', '[form="q-form-login"]'].filter(Boolean).join(', ');
            validator.qPatched = true;
        }
        return validator || null;
    };

    const validateSection = (section) => {
        const validator = jsValidator();
        const controls = controlsOf(section);
        let firstInvalid = null;
        controls.forEach((el) => {
            const handledByJsValidator = validator && !el.classList.contains('q-native');
            const ok = handledByJsValidator ? validator.element(el) !== false : el.checkValidity();
            if (!ok && !firstInvalid) firstInvalid = { el, native: !handledByJsValidator };
        });
        if (firstInvalid) {
            if (firstInvalid.native) firstInvalid.el.reportValidity();
            else firstInvalid.el.focus();
            return false;
        }
        if (section.dataset.qStep === 'datos' && form) {
            // activities_required con casillas múltiples: al menos una marcada.
            const group = section.querySelectorAll('input[type="checkbox"][name="activity_ids[]"]');
            const legend = section.querySelector('fieldset legend');
            if (group.length && legend && legend.textContent.trim().endsWith('*') && ![...group].some((el) => el.checked)) {
                showError('Debes elegir al menos una actividad.');
                return false;
            }
        }
        hideError();
        return true;
    };

    /* ---------- Pagos / resumen ---------- */
    const selectedQuota = () => (form ? form.querySelector('input[name="quota_id"]:checked') : null);
    const selectedMethod = () => (form ? form.querySelector('input[data-q-method]:checked') : null);

    const total = () => {
        const rows = [];
        const quota = selectedQuota();
        let sum = 0;
        if (quota && quota.dataset.price !== '') {
            rows.push([`Inscripción ${quota.dataset.label}`, Number(quota.dataset.price)]);
            sum += Number(quota.dataset.price);
        }
        const companion = form ? form.querySelector('[data-q-companion]') : null;
        if (companion && companion.checked) {
            const names = [...form.querySelectorAll('[data-q-companion-name]')].filter((el) => el.value.trim() !== '').length || 1;
            rows.push([`Acompañantes × ${names}`, Number(companion.dataset.price) * names]);
            sum += Number(companion.dataset.price) * names;
        }
        if (form) {
            form.querySelectorAll('input[name^="activity_ids"]:checked').forEach((el) => {
                const price = Number(el.dataset.price) || 0;
                if (price > 0) {
                    rows.push([el.dataset.label, price]);
                    sum += price;
                }
            });
        }
        return { rows, sum, hasQuota: !!quota };
    };

    const applyFreeState = () => {
        if (!form) return;
        const freeInput = form.querySelector('[data-q-free-input]');
        const methods = form.querySelector('[data-q-methods]');
        if (!freeInput || !methods) return;
        const quota = selectedQuota();
        const isFree = !!quota && quota.dataset.price !== '' && Number(quota.dataset.price) === 0;
        freeInput.disabled = !isFree;
        form.querySelector('[data-q-free-text]').hidden = !isFree;
        methods.hidden = isFree;
        methods.querySelectorAll('input[data-q-method]').forEach((radio) => {
            radio.disabled = isFree;
        });
    };

    const applyMethodNotes = () => {
        if (!form) return;
        const method = selectedMethod();
        form.querySelectorAll('[data-q-method-note]').forEach((note) => {
            note.hidden = !method || method.disabled || note.dataset.qMethodNote !== method.value;
        });
    };

    const renderSummary = () => {
        const target = form ? form.querySelector('[data-q-summary-rows]') : null;
        if (!target) return;
        const { rows, sum, hasQuota } = total();
        target.innerHTML = '';
        rows.forEach(([label, amount]) => {
            const row = document.createElement('div');
            row.className = 'q-summary-row';
            const left = document.createElement('span');
            left.textContent = label;
            const right = document.createElement('span');
            right.className = 'q-mono';
            right.textContent = money(amount);
            row.append(left, right);
            target.append(row);
        });
        form.querySelector('[data-q-summary-total]').textContent = hasQuota ? money(sum) : '—';
    };

    /* ---------- Render del paso actual ---------- */
    function refresh() {
        if (!form) return;
        applyFreeState();
        applyMethodNotes();
        renderSummary();

        allSteps.forEach((step) => {
            step.hidden = step !== steps[current];
        });
        const section = steps[current];
        const keys = steps.map((s) => s.dataset.qStep);
        page.querySelectorAll('[data-q-step-ind]').forEach((ind) => {
            const key = ind.dataset.qStepInd;
            const idx = keys.indexOf(key);
            ind.classList.toggle('is-done', (key === 'cuenta' && accountDone) || (idx !== -1 && idx < current));
            ind.classList.toggle('is-current', idx === current);
            ind.classList.toggle('is-skipped', idx === -1 && !(key === 'cuenta' && accountDone) && mode !== 'guest_account');
        });

        const { sum, hasQuota } = total();
        const quota = selectedQuota();
        if (footTop) footTop.textContent = section.dataset.footTop || '';
        if (footMain) {
            footMain.textContent = section.dataset.footMain || (hasQuota ? `${quota.dataset.label} · ${money(sum)}` : 'Elige una tarifa');
        }

        const isLoginTab = section.dataset.qStep === 'cuenta' && tab === 'login';
        const isFinal = section.hasAttribute('data-final') || isLoginTab;
        backBtn.hidden = current === 0;
        nextBtn.hidden = isFinal;
        submitBtn.hidden = !isFinal;
        if (nextLabel) nextLabel.textContent = section.dataset.nextLabel || 'Continuar';

        if (isLoginTab) {
            submitBtn.setAttribute('form', 'q-form-login');
            submitLabel.textContent = 'Iniciar sesión y continuar';
            if (footMain) footMain.textContent = 'Accede a tu cuenta';
        } else {
            submitBtn.removeAttribute('form');
            const method = selectedMethod();
            if (section.dataset.submitLabel) {
                submitLabel.textContent = section.dataset.submitLabel;
            } else if (method && !method.disabled && method.value === 'tarjeta' && hasQuota) {
                submitLabel.textContent = `Pagar ${money(sum)}`;
            } else {
                submitLabel.textContent = 'Confirmar inscripción';
            }
        }
    }

    const goTo = (index) => {
        current = Math.max(0, Math.min(steps.length - 1, index));
        hideError();
        refresh();
        // Al cambiar de paso, si el inicio del formulario quedó fuera de la vista, se vuelve a él.
        if (page.getBoundingClientRect().top < 0) page.scrollIntoView({ block: 'start', behavior: 'smooth' });
    };

    if (nextBtn) {
        nextBtn.addEventListener('click', () => {
            if (!validateSection(steps[current])) return;
            goTo(current + 1);
        });
    }
    if (backBtn) backBtn.addEventListener('click', () => goTo(current - 1));

    if (form) {
        form.addEventListener('change', (event) => {
            const target = event.target;
            if (target.matches('[data-q-companion]')) {
                form.querySelector('[data-q-companion-fields]').hidden = !target.checked;
            }
            if (target.matches('[data-q-toggle]')) {
                const panelEl = form.querySelector(target.dataset.qToggle);
                if (panelEl) panelEl.hidden = !target.checked;
            }
            if (target.matches('[data-q-usertype-tipo], [data-q-usertype-socio]')) {
                const params = new URLSearchParams({ inscribir: '1', tipo_usuario: form.querySelector('[data-q-usertype-tipo]').value });
                if (form.querySelector('[data-q-usertype-socio]').checked) params.set('es_socio', '1');
                window.location.href = `${window.location.pathname}?${params.toString()}`;
                return;
            }
            refresh();
        });
        form.addEventListener('input', (event) => {
            if (event.target.matches('[data-q-companion-name]')) refresh();
        });
        // Intro en un campo = botón principal del paso visible (no envía el
        // formulario entero desde el primer paso).
        page.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter' || !event.target.matches('input:not([type="checkbox"]):not([type="radio"]):not([type="file"])')) return;
            event.preventDefault();
            (nextBtn.hidden ? submitBtn : nextBtn).click();
        });

        const addCompanion = form.querySelector('[data-q-companion-add]');
        if (addCompanion) {
            addCompanion.addEventListener('click', () => {
                const hiddenInputs = [...form.querySelectorAll('[data-q-companion-name][hidden]')];
                if (hiddenInputs.length === 0) return;
                hiddenInputs[0].hidden = false;
                hiddenInputs[0].focus();
                if (hiddenInputs.length === 1) addCompanion.hidden = true;
            });
        }

        // Validación completa antes de enviar (el form es novalidate): si algún paso
        // tiene un campo inválido, se vuelve a ese paso y se señala.
        form.addEventListener('submit', (event) => {
            submitBtn.removeAttribute('aria-disabled');
            for (let i = 0; i < steps.length; i++) {
                if (steps[i].dataset.qStep === 'cuenta' && tab === 'login') continue;
                goToSilently(i);
                if (!validateSection(steps[i])) {
                    event.preventDefault();
                    return;
                }
            }
            goToSilently(steps.length - 1);
            submitBtn.setAttribute('aria-disabled', 'true');
        });
    }
    function goToSilently(index) {
        current = index;
        refresh();
    }

    /* ---------- Estado inicial ---------- */
    if (page.dataset.startLogin === '1') setTab('login');
    else setTab('registro');
    initPasswordMeters(page);
    refresh();
}

function init() {
    const page = document.querySelector('[data-q-inscribete]');
    if (page) initInscribete(page);
    // Pantallas de acceso (alta): medidor de contraseña.
    document.querySelectorAll('[data-q-access]').forEach((scope) => {
        if (!scope.querySelector('[data-q-inscribete]')) initPasswordMeters(scope);
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
